/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { createLogger } from 'redux-logger';
import { applyMiddleware, legacy_createStore as createStore } from 'redux';
import { defaultAppState } from './AppState';
import { appReducer } from './AppReducer';
import { createEpicMiddleware } from 'redux-observable';
import { persistStore } from 'redux-persist';
import { composeWithDevTools } from '@redux-devtools/extension';
import { login } from './auth/Auth.epics';
var epics = createEpicMiddleware();
var logger = createLogger({
    predicate: function (_getState, _action) { return process.env.NODE_ENV === 'development'; },
    diff: process.env.NODE_ENV === 'development',
});
export var store = createStore(appReducer, defaultAppState, process.env.NODE_ENV === 'production'
    ? applyMiddleware(epics, logger)
    : composeWithDevTools(applyMiddleware(epics, logger)));
epics.run(login);
export var persistedAppStore = persistStore(store);
